import './index.css'
import { Theme } from '@radix-ui/themes'
import clsx from 'clsx'
import React from 'react'
import Heading from 'components/ui/heading'
import Stack from 'components/ui/stack'
type Props = {
  title: string
  description: React.ReactNode
  buttons: React.ReactNode
  theme?: 'artist' | 'enterprise' | 'business-plans-switch'
}

/**
 * PricingBanner component for displaying promotional banners on pricing page
 *
 * A themed banner component that displays promotional content with title, description,
 * and action buttons. Supports different themes for artist plans, enterprise plans,
 * and business plan switching.
 *
 * @param props - Component props
 * @param props.title - Banner title to display
 * @param props.description - Banner description content (can include JSX)
 * @param props.buttons - Action buttons or button container
 * @param props.theme - Visual theme variant for styling
 * @returns JSX element containing the themed pricing banner
 */
const PricingBanner = ({
  title,
  description,
  buttons,
  theme,
}: Props): React.ReactNode => {
  return (
    <Theme appearance="dark" hasBackground={false}>
      <div
        className={clsx('PricingBanner', {
          'PricingBanner--artist': theme === 'artist',
          'PricingBanner--enterprise': theme === 'enterprise',
          'PricingBanner--business-plans-switch':
            theme === 'business-plans-switch',
        })}
      >
        <div className="PricingBanner__Content">
          <Stack space="xsmall">
            <Stack space="xxsmall">
              <div>
                <Heading size={600}>{title}</Heading>
              </div>
              <div className="PricingBanner__Description">{description}</div>
            </Stack>
            {buttons}
          </Stack>
        </div>
      </div>
    </Theme>
  )
}

export default PricingBanner
